import { BillingCycleInterval, BillingTier } from "types/generated";
import { formatDate } from "utils/date";

import {
  PAYMENT_FAILED_STATUSES,
  SELF_SERVICE_TIERS,
  SUBSCRIPTION_ACTIVE_STATUSES,
  V4_TIERS_SEQUENCE,
  V5_TIERS_SEQUENCE,
} from "./constants";
import { StripeSubscriptionStatus } from "./types";

export const formatBillingDate = (date: number) =>
  formatDate({ date: date * 1000, format: "statusDate" });

export const isLegacyBillingTier = (tier: BillingTier) => {
  return !V4_TIERS_SEQUENCE.includes(tier) && !V5_TIERS_SEQUENCE.includes(tier);
};

export const isSelfServiceTier = (tier: BillingTier) => SELF_SERVICE_TIERS.includes(tier);

export const isPaymentFailed = (status: StripeSubscriptionStatus) => {
  return PAYMENT_FAILED_STATUSES.includes(status);
};

export const isSubscriptionActive = (status: StripeSubscriptionStatus) => {
  return SUBSCRIPTION_ACTIVE_STATUSES.includes(status);
};

export const formatPrice = (
  price: number,
  interval: BillingCycleInterval,
  fullInterval: boolean = false
) => {
  const monthPostfix = fullInterval ? "month" : "mo";
  const yearPostfix = fullInterval ? "year" : "y";

  return `$${price} / ${interval === BillingCycleInterval.Monthly ? monthPostfix : yearPostfix}`;
};
